var exports = {
  "P": "xa15a2ab7--9c3729--label",
};

module.exports = exports;
